import { ChangeDetectionStrategy, Component, computed, input, model, output } from '@angular/core';
import {
  AgentNotificationSettingsDto,
  AgentNotificationsUpdateDto,
  AgentProfileDto,
} from '@workspace/data-types';
import { AuraEditWrapperComponent } from '@workspace/ng-aura';
import { AgentNotificationsDisplayComponent } from '../display/agent-notifications-display.component';
import { AgentNotificationsFormComponent } from '../form/agent-notifications-form.component';

@Component({
  selector: 'etxe-agent-notifications-edit',
  imports: [AuraEditWrapperComponent, AgentNotificationsFormComponent, AgentNotificationsDisplayComponent],
  templateUrl: './agent-notifications-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentNotificationsEditComponent {
  readonly initialProfile = input<AgentProfileDto | null>(null);
  readonly initialSettings = input<AgentNotificationSettingsDto | undefined>(undefined);
  readonly isEditing = model<boolean>(false);
  readonly isAllowedToEdit = input<boolean>(true);

  readonly saved = output<AgentNotificationsUpdateDto>();
  readonly profileSaved = output<AgentProfileDto>();

  readonly currentSettings = computed<AgentNotificationSettingsDto | undefined>(() => {
    return this.initialSettings() ?? this.initialProfile()?.settings?.notifications;
  });

  onSave(dto: AgentNotificationsUpdateDto | null): void {
    if (!dto) return;
    this.saved.emit(dto);
    const profile = this.initialProfile();
    if (profile) {
      this.profileSaved.emit({
        ...profile,
        settings: {
          ...profile.settings,
          notifications: dto.notifications,
        },
      });
    }
  }
}
